function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { PLATFORM_MANIFEST_FETCH_ERROR } from "constants/bigbrain-event-types";
import { getPlatformLinkByEnvironment } from "constants/platform-links";
import { PLATFORM_MANIFEST_ENDPOINT } from "constants/prefetch-constants";
import ProviderKeys from "./providers-keys";
const { BaseDataProvider } = require("./base-data-provider");
const { handleServerException } = require("../../exceptions-handling-service/exceptions-handling-service");
const REFRESH_INTERVAL_MINUTES = 30 * 60;
class PlatformManifestProvider extends BaseDataProvider {
    key() {
        return `${ProviderKeys.MANIFEST_DATA}`;
    }
    refreshInterval() {
        return REFRESH_INTERVAL_MINUTES;
    }
    getData() {
        return _async_to_generator(function*() {
            try {
                const options = {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    method: "GET",
                    pragma: "no-cache"
                };
                const url = getPlatformLinkByEnvironment(PLATFORM_MANIFEST_ENDPOINT);
                const res = yield fetch(url, options);
                if ((res === null || res === void 0 ? void 0 : res.status) === 200) {
                    const response = yield res.json();
                    return {
                        success: true,
                        response
                    };
                }
                throw new Error(res.statusText);
            } catch (e) {
                handleServerException({
                    e,
                    bbEventParams: {
                        name: PLATFORM_MANIFEST_FETCH_ERROR,
                        direct_object: e.message
                    }
                });
                console.error(e.message);
                throw e;
            }
        })();
    }
    constructor(){
        super();
    }
}
module.exports = {
    PlatformManifestProvider
};
